<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-blurbs element-with-heading" id="praise-for-graham-smith">
<div class="heading heading-with-title heading-without-image" id="praise-for-graham-smith-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Praise for Graham Smith</h1>
</div>
</div>
</div>
</div>
<div class="text" id="praise-for-graham-smith-text">
<p class="first first-in-chapter first-full-width">"This is one hell of a rollercoaster that just kept me glued to my kindle, but it was a roller coaster I didn’t want to end." <b><i>Claire Knight - A Knight's Reads</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"The story itself was very entertaining and kept me gripped throughout the entire book. It seems that Graham Smith has a knack of really capturing the story and ensuring it’s pleasing to the reader." <b><i>Sean Talbot - Seans Book Reviews</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"Graham Smith has a talent for writing characters that are so personable and I do wonder if my emotions can handle much more! A fantastic addition to the Jake Boulder series; five stars from me." <b><i>Ellen Devonport - Bibliophile Book Club</i></b></p>
<p class="subsq"> </p>
<p class="subsq"><b><i>"</i></b>Past Echoes is an excellent title for this extremely exciting book that is full of gameplay..." <b><i>Alexina Golding – Bookstormer</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"Another book I could talk about forever…I cannot tell you all the WOW, OMFG and WTAF moments because this is one book you NEED to read for yourself." <b><i>Noelle Holten – CrimeBookJunkie</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"I find Graham Smith’s writing to be unique like the work of Karin Slaughter. His prose is completely purposeful and done with taste..." <b><i>Samantha Ellen - Clues and Reviews</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"This is another fantastic cat and mouse thriller. I haven’t been disappointed yet by Smith and his writing – you’re on the edge of your seat for the majority of the book." <b><i>Jessica Robins - Jessicamap Reviews</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"Past Echoes gives you thrilling, psychological drama at it’s best with Jake Boulder, meaner and tougher than ever before." <b><i>Sharon Bairden - Chapter In My Life</i></b></p>
<p class="subsq"> </p>
<p class="subsq"><b><i>"</i></b>There were a lot of “OMG!” moments in this book, and I can’t wait to see what Mr Smith has planned for Jake in the next instalment." <b><i>Danielle Ryan - The Blonde Likes Books</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"Raw, evocative and deliciously intense. I loved it!" <b><i>Emma Welton – damppebbles</i></b> </p>
<p class="subsq">"If it’s possible, the Jake Boulder series is getting even better. This book just grabbed me and didn’t let go until the very end..." <b><i>Ashley Gillan - (e)Book Nerd Reviews</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"Great characters, a fast-paced narrative and an addictive storyline all add up to make this thriller a must read!" <b><i>Joanne Robertson</i></b> - <b><i>My Chestnut Reading Tree</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"Smith excels in scenes where Boulder has to face down his adversaries. There's plenty of smart dialogue and great action." <b><i>Colman Keane - Col's Criminal Library</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"I thoroughly enjoyed this book, it was one of those books that you want to read in one sitting, it is fast-paced and full of action!" <b><i>Donna Maguire - Donnas Book Blog</i></b></p>
<p class="subsq"> </p>
<p class="subsq">"I have loved each and every one of these books, I love Graham's style of writing, the knack he has to get the reader involved in the story is first class." <b><i>Vicki Wilkinson - ILoveReadingUK</i></b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise-for-graham-smith.vue?24afab5e